<template>
    <!-- 试题分类管理 -->
    <div class="classSetting">
        <el-row class="tableHearInputBox" type="flex" justify="space-between">
            <el-col>
                <el-input v-model.trim="query.query" placeholder="请输入科目名称" style="width: 200px; margin-right:10px"
                    @keyup.enter.native="freshLoad" @clear="
                        query.query = '';
                    freshLoad();
                    " clearable suffix-icon="el-icon-search"></el-input>
                <Debounce>
                    <el-button style="margin-right:10px" size="small" @click="freshLoad">查询</el-button>
                </Debounce>
                <el-select v-model="query.subjectLevel" style="margin-right:10px" @change="freshLoad" filterable
                    placeholder="请选择">
                    <el-option label="全部级别" value=""></el-option>
                    <el-option v-for="item in levelList" :key="item.subjectLevel" :label="item.subjectLevelName"
                        :value="item.subjectLevel">
                    </el-option>
                </el-select>
                <el-select v-model="query.type" @change="freshLoad" filterable placeholder="请选择">
                    <el-option label="全部归属部分" value=""></el-option>
                    <el-option v-for="item in typeSeleList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-button type="primary" size="small" @click="operatInfo(1)">添加</el-button>
        </el-row>
        <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
            :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
            @selection-change="handleSelectionChange" :height="$store.getters.getTableHeight">
            <el-table-column prop="subjectName" label="科目名称" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column prop="subjectLevel" label="级别" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column prop="type" label="归属部分" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="nodes" label="知识点类别" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column prop="num" label="关联题目数" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" class="tableContentUpdateBut" size="small" @click="operatInfo(2, scope.row)">修改
                    </el-button>
                    <span style="margin:0px 10px;"
                        v-if="$roleFilter('judge:update') && $roleFilter('judge:init:password')">|</span>
                    <Debounce>
                        <el-button style="color: #ff3e3e;" type="text" size="small" @click="operatInfo(3, scope.row)">删除
                        </el-button>
                    </Debounce>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
            @pagination="tableLoad" />
        <el-dialog custom-class="dailogComponents" :title="visibleType == 1 ? '添加' : '修改'" :visible.sync="visible"
            :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="400px">
            <div class="dialogBox">
                <el-row type="flex" class="dialogTitle" justify="space-between">
                    <el-col :span="7">
                        <p><span v-if="visibleType == 1" style="color:red;">*</span>科目名称:</p>
                    </el-col>
                    <el-col :offset="1">
                        <el-select v-model="visibleObj.subjectId" filterable placeholder="请选择" style="width:100%"
                            v-if="visibleType == 1" @change="changeSub">
                            <el-option v-for="item in subjectList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                        <div style="line-height:260%" v-else>{{ visibleObj.subjectName }}</div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="dialogTitle" justify="space-between">
                    <el-col :span="7">
                        <p><span v-if="visibleType == 1" style="color:red;">*</span>级别:</p>
                    </el-col>
                    <el-col :offset="1">
                        <el-select v-model="visibleObj.subjectLevel" filterable placeholder="请选择" style="width:100%"
                            v-if="visibleType == 1">
                            <el-option v-for="item in jbList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                        <div style="line-height:260%" v-else>{{ visibleObj.subjectLevel }}</div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="dialogTitle" justify="space-between">
                    <el-col :span="7">
                        <p><span v-if="visibleType == 1" style="color:red;">*</span>归属部分:</p>
                    </el-col>
                    <el-col :offset="1">
                        <el-select v-model="visibleObj.type" filterable placeholder="请选择" style="width:100%"
                            v-if="visibleType == 1">
                            <el-option v-for="item in typeSeleList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                        <div style="line-height:260%" v-else>{{ visibleObj.type }}</div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="dialogTitle" justify="space-between">
                    <el-col :span="7">
                        <p><span style="color:red;">*</span>知识点类别:</p>
                    </el-col>
                    <el-col :offset="1">
                    </el-col>
                </el-row>
                <el-row type="flex" class="dialogTitle" justify="space-between" v-for="(item, index) in visibleObj.nodes"
                    :key="index">
                    <el-col :span="20">
                        <el-input v-model="visibleObj.nodes[index].name" placeholder="请输入" maxlength="10"></el-input>
                    </el-col>
                    <el-col :span="4">
                        <div class="iconDiv">
                            <img class="changeIcon" src="@/assets/img/addRow.png" alt="" @click="addKnow">
                            <img class="changeIcon" src="@/assets/img/deleteRow.png" alt="" @click="deleteKnow(index)"
                                v-if="visibleObj.nodes.length > 1">
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="dailogButBox" justify="center">
                    <el-col :span="7">
                        <el-button size="medium" @click="visible = false">取消</el-button>
                    </el-col>
                    <el-col :span="4">
                        <el-button size="medium" type="primary" @click="submit">确认</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown'

export default {
    components: {
        FileOperatDropdown,
    },
    data() {
        return {
            tableList: [],
            tableSelectList: [],
            tableIsLoad: true,
            roleList: [],
            visible: false,
            visibleType: 0, //删除
            visibleObj: {
                subjectLevel: "", //级别
                type: "", //归属部分
                nodes: [{ name: "", orderNum: 1 }], //知识点类别
                subjectId: "", //科目名称
            },
            query: {
                query: "",
                pageNum: 1, // 当前页
                pageSize: 15, // 每页显示条数
                total: 1, //总条数
                subjectLevel: '', //级别
                type: '', //归属部分
            },
            levelList: [],
            typeSeleList: [],
            subjectList: [],
            jbList: [],
            typeList: ['乐理知识', '音乐素养', '上传音频', '练耳'],
            amendId: ''
        };
    },
    mounted() {
        this.getSelects();
        this.tableLoad();
    },
    methods: {
        getSelects() {
            // 级别下拉框
            this.$axios.get("/basicQuestions/level").then((res) => {
                this.levelList = res.data.data
            });
            // 归属部分下拉框
            this.$axios.get("/basicQuestions/type").then((res) => {
                this.typeSeleList = res.data.data
            });
            // 科目级别级联下拉框
            this.$axios.get("/basicQuestions/subjectAndLevel").then((res) => {
                this.subjectList = res.data.data
            });
        },
        changeSub(val) {
            this.visibleObj.subjectLevel = ''
            this.jbList = this.subjectList.filter(item => {
                return item.value == val
            })[0].children
            console.log(this.jbList);
        },
        addKnow() {
            if (this.visibleObj.nodes.length < 21) {
                this.visibleObj.nodes.push({ name: "", orderNum: this.visibleObj.nodes.length + 1 })
            }
        },
        deleteKnow(num) {
            this.visibleObj.nodes.splice(num, 1)
            this.visibleObj.nodes.forEach((item, index) => {
                item.orderNum = index + 1
            })
        },
        freshLoad() {
            this.query.pageNum = 1
            this.tableLoad()
        },
        tableLoad() {
            this.$axios.post("/basicQuestions/list", this.query).then((res) => {
                let {
                    list,
                    total
                } = res.data.data;
                this.tableList = list;
                this.query.total = total;
                this.tableIsLoad = false;
            });
        },
        handleSelectionChange(val) {
            this.tableSelectList = val;
        },
        operatInfo(type, row) {
            this.visibleType = type;
            this.amendId = ''
            this.visibleObj = {
                subjectLevel: "", //级别
                type: "", //归属部分
                nodes: [{ name: "", orderNum: 1 }], //知识点类别
                subjectId: "", //科目名称
            }
            if (type === 1) {
                //添加
                this.visible = true;
            } else if (type === 2) {
                this.amendId = row.id
                this.$axios.get(`/basicQuestions/selectOne/${row.id}`).then((res) => {
                    this.visibleObj = res.data.data
                    let arr = this.visibleObj.nodes.split(',')
                    this.visibleObj.nodes = arr.map((item, index) => {
                        return { name: item, orderNum: index + 1 }
                    })
                    this.visible = true;
                });
                //修改
                // this.visibleObj = JSON.parse(JSON.stringify(row));
            } else if (type === 3) {
                this.$dailog({
                    title: "删除",
                    context: "是否删除该知识点类别？",
                    callbackFun: () => {
                        this.deleteKnows(row);
                    },
                });
            }
        },
        // 删除知识点类别
        deleteKnows(row) {
            this.$axios({
                method: "delete",
                url: `/basicQuestions/delete/${row.id}`,
            }).then((res) => {
                this.$message({
                    type: "success",
                    message: "删除成功!", duration: 1000
                });
                this.tableLoad()
            });
        },
        submit() {
            let {
                subjectLevel,
                type,
                nodes,
                subjectId,
            } = this.visibleObj;
            if (subjectId === "" || subjectLevel === "" || type === "") {
                this.$message({
                    type: "error",
                    message: "必填项不能为空!", duration: 1000
                });
                return;
            }
            let flag = 0
            nodes.forEach(item => {
                if (item.name == '') {
                    flag += 1
                }
            })
            if (flag != 0) {
                this.$message({
                    type: "error",
                    message: "必填项不能为空!", duration: 1000
                });
                return;
            }
            let data = {}
            let url = this.visibleType === 1 ? "/basicQuestions/save" : `/basicQuestions/update/${this.amendId}`;
            if (this.visibleType === 1) {
                data = this.visibleObj
            } else {
                data = this.visibleObj.nodes
            }
            let obj = {
                method: 'post', url, data
            }
            this.$axios(obj).then((res) => {
                this.$message({
                    type: "success",
                    message: "保存成功!", duration: 1000
                });
                this.visible = false;
                this.tableLoad();
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.iconDiv {
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;

    .changeIcon {
        line-height: 50px;
        width: 46%;
    }
}
</style>
  